(() => {
  /**
   * monitorProductImpressions tracks impressions on the fly when they become visible.
   */
  let intersectionObserver;
  let debouncedPush;
  let impressionsQueue = [];
  const impressionRecord = {};

  const saveTrackedImpression = (product) => {
    impressionRecord[`${product.id}_${product.listName}`] = true;
  };

  const impressionAlreadyTracked = (product) => (
    !!impressionRecord[`${product.id}_${product.listName}`]
  );

  async function trackSingleImpression($element) {
    const productId = $element.data('id');
    let prodInfo = TrackApp.analyticsCacheGet(productId);
    if (!prodInfo) {
      prodInfo = await TrackApp.fetch({ productsData: [{ productId }] });
      prodInfo = TrackApp.analyticsCacheGet(productId);
    }

    const product = TrackApp.fillProductsFields({ productInformation: [prodInfo] }, {
      listPosition: TrackApp.getListPosition($element),
      $elem: $element,
    })[0];

    if (product && !impressionAlreadyTracked(product)) {
      saveTrackedImpression(product);
      impressionsQueue.push(product);
      debouncedPush();
    }
  }

  function monitorProductImpressions() {
    if (!App.settings.monitorProductImpressions) {
      return;
    }

    // Ignore impressions tracking for unsupported browsers
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    if (intersectionObserver) {
      intersectionObserver.disconnect();
    }
    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.4) {
          entry.target.setAttribute('data-viewed', '');
          intersectionObserver.unobserve(entry.target);
          trackSingleImpression($(entry.target));
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.4,
    });

    [...document.querySelectorAll('[data-product-box]:not([data-viewed])')]
      .forEach((el) => intersectionObserver.observe(el));
  }

  function initMonitorProductImpressions() {
    monitorProductImpressions();
    debouncedPush = window.debounce(() => {
      TrackApp.trackImpression('productListView', impressionsQueue);
      impressionsQueue = [];
    }, 100);
  }

  window.TrackApp.monitorProductImpressions = monitorProductImpressions;
  window.TrackApp.initMonitorProductImpressions = initMonitorProductImpressions;
})();
